// components/Loading.tsx

interface LoadingProps {
  size?:
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "4xl"
    | "5xl"
    | "6xl"
    | "full";
  // Defines the base border width for all sides - defaulting to thinner '2'
  borderSize?: "2" | "4" | "8";
  // Defines the visible color part - defaulting to a softer neutral
  color?: string; // e.g., "blue-400", "neutral-300"
}

export default function Loading({
  size = "xl", // Maybe default to slightly smaller like 'xl' (h-32 w-32)? Adjust as you like.
  borderSize = "2", // *** Use thinner border by default ***
  color = "neutral-300", // *** Use softer neutral color by default ***
}: LoadingProps) {
  const sizeClasses = () => {
    switch (size) {
      case "sm":
        return "h-6 w-6";
      case "md":
        return "h-12 w-12";
      case "lg":
        return "h-24 w-24";
      case "xl":
        return "h-32 w-32";
      case "2xl":
        return "h-40 w-40";
      case "3xl":
        return "h-48 w-48";
      case "4xl":
        return "h-56 w-56";
      case "5xl":
        return "h-64 w-64";
      case "6xl":
        return "h-72 w-72";
      case "full":
        return "h-full w-full";
      default:
        return "h-32 w-32"; // Fallback
    }
  };

  // Construct border classes using standard pattern
  const borderBaseClass = `border-${borderSize}`; // Defaults to border-2
  const borderStyle = "border-solid";
  const borderColorClass = `border-${color}`; // Defaults to border-neutral-300
  // Make one side transparent to create the spinning effect
  // Using left transparent often feels slightly smoother visually than top
  const transparentSide = "border-l-transparent"; // *** Changed to left side transparent ***

  return (
    <div
      className="flex items-center justify-center h-full"
      aria-label="Loading content..."
    >
      <div
        className={`animate-spin rounded-full ${sizeClasses()} ${borderBaseClass} ${borderStyle} ${borderColorClass} ${transparentSide}`}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}
